import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Buffer } from 'buffer';
import { BehaviorSubject } from 'rxjs';
import { PerfomanceLogIndexdbService } from 'src/app/service/perfomance-log-indexdb.service';
import { XmlLogIndexdbService } from 'src/app/service/xml-log-indexdb.service';

import { User } from '../model/auth/user';
import { AddionalOffersData, BookingReferences, PerformanceLog, SandboxPage, UpsellOffers } from '../model/page/sandbox-page';
import { AddAncilliariesScreen } from '../model/screen/add-ancilliaries-screen';
import { AddBaggageScreen } from '../model/screen/add-baggage-screen';
import { AirlineOffersScreen } from '../model/screen/airline-offers-screen';
import { APIConnectionProfile, APIConnectionProfileScreen } from '../model/screen/api-connection-profile-screen';
import { CancelBookingGetRefundScreen } from '../model/screen/cancel-booking-get-refund';
import { ChangeFlightDateTimeScreen } from '../model/screen/change-flight-date-time-screen';
import { ConfirmBookingScreen } from '../model/screen/confirm-booking-screen';
import { DisruptedOrderViewerScreen, RequestBody } from '../model/screen/disrupted-order-viewer-screen';
import { FilterOffersScreen } from '../model/screen/filter-offers-screen';
import { FindOrdersScreen } from '../model/screen/find-order-screen';
import { OfferPriceScreen } from '../model/screen/offer-price-screen';
import { OrderDetailsScreen } from '../model/screen/order-details-screen';
import { PassengerDetailScreen } from '../model/screen/passenger-detail-screen';
import { SearchFlightsScreen } from '../model/screen/search-flights-screen';
import { SeatSelectionScreen } from '../model/screen/seat-selection-screen';
import { YourBookingScreen } from '../model/screen/your-booking-screen';
import { ConfigService } from './config.service';
import { SandboxPageStateHelperService } from './sandbox-page-state-helper.service';
import { XmlToJsonParserService } from './xml-to-json-parser.service';
import { config } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SandboxPageStateService {
  SEARCH_FLIGHTS_REQUEST_TEMPLATE = './assets/json/search-flights/request/search-flights-request-template.json';
  REQUOTE_REQUEST_TEMPLATE = './assets/json/order-reshop/requote/request/requote-request-template.json';
  PRIME_BAG_SERVICE_REQUEST_TEMPLATE = './assets/json/add-bagges-service-response/prime-sale/request/service-request-template.json';
  AIRLINE_OFFER_TEMPLATE = './assets/json/air-shopping-offers/request/airline-offer-request-template.json';
  ADD_ANCILLIARIE_SERVICELISTS_REQUEST_TEMPLATE = './assets/json/add-bagges-service-response/prime-sale/request/service-request-template.json';
  ORDERCREATE_REQUEST_TEMPLATE = './assets/json/order-create/request/order-create-request-template.json';

  ORDERCHANGE_ISSUE_TICKET_REQUEST_TEMPLATE = './assets/json/order-change/request/order-change-issue-ticket-request-template.json';
  ORDERCHANGE_REQUOTE_TICKET_REQUEST_TEMPLATE = './assets/json/order-change/request/order-change-requote-ticket-request-template.json';
  ORDERCHANGE_PASSENGER_DETAILS_UPDATE_TEMPLATE = './assets/json/passenger-name-change/passenger-details-update-request-template.json';
  ORDERCHANGE_PAX_REQUEST_TEMPLATE = './assets/json/split-booking/request/order-change-pax-request-template.json';
  ORDERCHANGE_SPLIT_REQUEST_TEMPLATE = './assets/json/split-booking/request/order-change-split-request-template.json';
  ORDERCHANGE_NAME_CHANGE_REQUEST_TEMPLATE = './assets/json/passenger-name-change/passenger-name-change-request-template.json';
  ORDERCHANGE_ACCEPT_REQUEST_TEMPLATE = './assets/json/order-change/request/order-change-accpet-request-template.json';
  ORDERCHANGE_CHANGE_DATE_TIME_BOOKING_REQUEST_TEMPLATE = './assets/json/order-change/request/order-change-change-date-time-request-template.json';

  CANCEl_BOOKING_REQUEST_TEMPLATE = './assets/json/cancel-booking-get-refund-options/request/cancel-get-refund-order-cancel-request-template.json';
  CANCEL_BOOKING_REQUEST_TEMPLATE = './assets/json/cancel-booking-get-refund-options/request/cancel-get-refund-order-cancel-request-template.json';
  CANCEl_BOOKING_GET_REFUND_REQUEST_TEMPLATE = './assets/json/cancel-booking-get-refund-options/request/cancel-get-refund-order-reshop-request-template.json';
  CANCEL_BOOKING_GET_REFUND_REQUEST_TEMPLATE = './assets/json/cancel-booking-get-refund-options/request/cancel-get-refund-order-reshop-request-template.json';
  CANCEL_HOLD_BOOKING_REQUEST_TEMPLATE = './assets/json/cancel-booking-get-refund-options/request/cancel-hold-booking-request-template.json';

  CHANGE_BOOKING_REPRICE_TEMPLATE = './assets/json/order-reshop/reprice/request/rerpice-request-template.json';
  CHANGE_BOOKING_RESHOP_TEMPLATE = './assets/json/order-change/request/order-reshop-change-date-time-request-template.json';

  OCN_CANCEL_AND_REACCOMODATION_REQUEST_TEMPLATE = './assets/json/ocn-cancel-and-reaccomodation/ocn-cancel-and-reaccomodation-request.json';
  ORDER_DETAILS_REQUEST_TEMPLATE = './assets/json/order-details/request/order-list-request-template.json';

  SEARCH_FLIGHTS_SCREEN_URL = '/AirShopping/17.2/V1';
  AIRLINE_OFFERS_SCREEN_URL = '/OfferPrice/17.2/V2';
  SEAT_SELECTION_SCREEN_URL = '/SeatAvailability/17.2/V2';
  REQUOTE_REQUEST_SCREEN_URL = '/OrderReshop/17.2/V3';
  OFFER_PRICE_SCREEN_SERVICE_LIST_URL = '/ServiceList/17.2/V1';
  OFFER_PRICE_SCREEN_ORDER_CREATE_URL = '/OrderCreate/17.2/V5';
  OFFER_PRICE_SCREEN_ORDER_CANCEL_URL = '/OrderCancel/17.2/V1';
  ORDER_CANCEL_SCREEN_URL = '/OrderCancel/17.2/V1';
  ORDER_CHANGE_URL = '/OrderChange/17.2/V4';
  REQUOTE_HELD_ORDER_CHANGE_URL = '/OrderChange/17.2/V4';
  FIND_ORDER_SCREEN_URL = '/OrderRetrieve/17.2/V3';
  ADD_ANCILLIARIES_SCREEN_SERVICE_LIST_URL = '/ServiceList/17.2/V1';
  CHANGE_BOOKING_ORDER_REPRICE_URL = '/OrderReshop/17.2/V3';
  OCN_CANCEL_AND_REACCOMODATION_SEVICE_URL = '/DisruptBooking/V1/orders/PNR/disruptbookings';
  OCN_MESSAGE_OPERATOR_API_URL = '/update-ocn-messages';
  ORDER_LIST_API_URL = '/OrderList/19.1/V1';

  private sandboxPage: SandboxPage = {} as SandboxPage;

  public sandboxScreenDataSource = new BehaviorSubject<any>({});
  sandboxScreenData = this.sandboxScreenDataSource.asObservable();

  private isRefresh = new BehaviorSubject<boolean>(false);
  castResfreshObs = this.isRefresh.asObservable();

  private isSearchFliterRefresh = new BehaviorSubject<boolean>(false);
  isSearchFliterRefreshState = this.isSearchFliterRefresh.asObservable();

  constructor(
    private perfomanceLogIndexdbService: PerfomanceLogIndexdbService,
    private xmlLogIndexdbService: XmlLogIndexdbService,
    private configService: ConfigService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private sandboxPageStateHelperService: SandboxPageStateHelperService,
    private httpClient: HttpClient
  ) {
    this.resetSandboxPage();
    this.resetUser();
    this.sandboxPage.activeAPIConnectionProfile = this.getActiveAPIConnectionProfile();
  }

  getConfig() {
    return this.configService.getConfig();
  }
  updateIndexDBConfig(config: any) {
    this.sandboxPage.indexDBConfig = config;
  }
  getIndexDBConfig() {
    return this.sandboxPage.indexDBConfig;
  }

  updateisSearchFliterRefresh(isSearchFliterRefresh: boolean) {
    this.isSearchFliterRefresh.next(isSearchFliterRefresh);
  }

  updateisResfresh(isRefresh: boolean) {
    this.isRefresh.next(isRefresh);
  }

  resetSandboxPage(retainSideMenu?: boolean, retainSplitBookingData?: boolean) {
    if (!retainSideMenu) {
      this.sandboxPage.sandboxMenu = {
        distruptedPnrCount: this.getDistruptedPnrCount(),
        sideMenu: 'searchOffer',
        hideSideMenu: 'No',
        mainMenu: 'none',
        disableOfferFilter: true,
        showError: 'No',
        errorMessage: '',
        showWarning: 'No',
        warningMessage: '',
        widthMainMenu: 'width70',
        showSuccess: 'No',
        successMessage: ''
      };
    }
    if (!retainSplitBookingData) {
      this.sandboxPage.findOrderFormValue = '';
      this.sandboxPage.bookingReferences = {} as BookingReferences;
    }
    this.sandboxPage.findOrdersScreen = {} as FindOrdersScreen;
    this.sandboxPage.yourBookingScreen = {} as YourBookingScreen;
    this.sandboxPage.confirmBookingScreen = {} as ConfirmBookingScreen;
    this.sandboxPage.offerPriceScreen = {} as OfferPriceScreen;
    this.sandboxPage.changeFlightDateTimeScreen = {} as ChangeFlightDateTimeScreen;
    this.sandboxPage.searchFlightsScreen = {} as SearchFlightsScreen;
    this.sandboxPage.airlineOffersScreen = {} as AirlineOffersScreen;
    this.sandboxPage.passengerDetailScreen = {} as PassengerDetailScreen;
    this.sandboxPage.seatSelectionScreen = {} as SeatSelectionScreen;
    this.sandboxPage.addBaggageScreen = {} as AddBaggageScreen;
    this.sandboxPage.cancelBookingGetRefundScreen = {} as CancelBookingGetRefundScreen;
    this.sandboxPage.disruptedOrderViewerScreen = {} as DisruptedOrderViewerScreen;
    this.sandboxPage.AddionalOffersData = {} as AddionalOffersData[];
    this.sandboxPage.UpsellOffers = {} as UpsellOffers[];
    this.sandboxPage.requestMap = new Map();
    this.sandboxPage.responseMap = new Map();
    this.sandboxPage.jsonRequestMap = new Map();
    //this.sandboxPage.xmlLogsMap = new Map();
    //this.sandboxPage.performanceLogs = [];
    //this.sandboxPage.xmlLogsMap = this.getXmlLogFromIndexDB();
    //this.sandboxPage.performanceLogs =this.getPerfomanceLogFromIndexDB();

    this.addSandboxScreenData(this.sandboxPage);
  }

  getSandboxPage() {
    return this.sandboxPage;
  }

  updateSandboxPage(sandboxPage: SandboxPage) {
    this.sandboxPage = sandboxPage;
  }

  getAddionalOffersData() {
    return this.getSandboxPage().AddionalOffersData;
  }

  updateAddionalOffersData(AddionalOffersData: AddionalOffersData[]) {
    this.getSandboxPage().AddionalOffersData = AddionalOffersData;
  }

  getUpsellOfersDetails() {
    return this.getSandboxPage().UpsellOffers;
  }

  updateUpsellOffersData(UpsellOffers: UpsellOffers[]) {
    this.getSandboxPage().UpsellOffers = UpsellOffers;
  }

  updateSandboxDataSource(sandboxData: any) {
    this.updateSandboxPage(this.sandboxPageStateHelperService.updateSandboxDataSource(this.getSandboxPage(), sandboxData));
    this.setTimeoutForScreens(sandboxData);
  }

  clearLocalStorage(retainTokenStorage?: boolean, retainRedirectURL?: boolean) {
    if (!retainTokenStorage) {
      localStorage.removeItem('access_token');
    }

    if (!retainRedirectURL) {
      localStorage.removeItem('redirect_url');
    }

    localStorage.removeItem('preferred_userName');
    localStorage.removeItem('siteUser');
    localStorage.removeItem('sandboxPage');
    localStorage.removeItem('logData');
  }

  getTokenObject(): any {
    const token_storage = localStorage.getItem('access_token');
    
    if (!token_storage || token_storage === 'undefined') {
      return this.handleInvalidToken();
    }
    try {
      const parsed = JSON.parse(token_storage);
      if (parsed && typeof parsed === 'object' && 'access_token' in parsed) {
        return this.processStandardToken();
      }
    } catch (e) {
    }
    
    return this.processEntraToken();
  }

  private handleInvalidToken(): boolean {
    this.clearLocalStorage(false, true);
    this.resetUser();
    return false;
  }

  private processEntraToken(): any {
    const token_storage = localStorage.getItem('access_token');
    try {
      const payload = token_storage ? token_storage.split('.')[1] : '';
      const decoded = JSON.parse(this.getDecodedBase64String(payload));
      const tokenExpiry = new Date(decoded.exp * 1000);

      if (tokenExpiry > new Date()) {
        return { access_token: token_storage };
      }
    } catch (e) {
      // Token parsing failed
    }

    return this.handleInvalidToken();
  }

  private processStandardToken(): any {
    const token_storage = localStorage.getItem('access_token');
    
    try {
      const token = token_storage ? JSON.parse(token_storage) : '';
      
      if (!token?.access_token) {
        return this.handleInvalidToken();
      }

      const tokenExpiry = new Date(JSON.parse(this.getDecodedBase64String(token.access_token.split('.')[1])).exp * 1000);
      
      return tokenExpiry > new Date() ? token : this.handleInvalidToken();
    } catch (e) {
      return this.handleInvalidToken();
    }
  }
  setTimeoutForScreens(sandboxData: any) {
    setTimeout(() => {
      this.addSandboxScreenData(this.getSandboxPage());
    }, 100);

    if (sandboxData.sandboxScreen === 'filter-offers-screen' || sandboxData.sandboxScreen == 'search-flights-screen') {
      setTimeout(() => {
        this.updateSandboxMainMenu('airline-offers');
      }, 200);
    }
    if (sandboxData.sandboxScreen === 'your-booking-screen') {
      setTimeout(() => {
        this.updateSandboxSideMenu('findOrder');
      }, 200);
    }
    if (sandboxData.sandboxScreen === 'find-orders-screen-issue-ticket' || sandboxData.sandboxScreen === 'find-orders-screen-requote-ticket') {
      setTimeout(() => {
        this.updateSandboxMainMenu('your-booking-screen');
      }, 200);
    }

    if (sandboxData.sandboxScreen === 'find-orders-screen-cancel-booking-get-refund-ticket' || sandboxData.sandboxScreen === 'find-orders-screen-cancel-booking-issue-voucher-ticket') {
      setTimeout(() => {
        this.updateSandboxMainMenu('your-booking-screen');
      }, 200);
    }

    if (sandboxData.sandboxScreen === 'requote-ticket-success-response' || sandboxData.sandboxScreen === 'issue-ticket-success-response') {
      setTimeout(() => {
        this.updateSandboxMainMenu('your-booking-screen');
      }, 200);
    }

    if (sandboxData.sandboxScreen === 'ocn-cancel-and-reaccomodation') {
      setTimeout(() => {
        this.updateSandboxMainMenu('your-booking-screen');
      }, 200);
    }
  }

  updateSandboxMainMenu(menu: any) {
    this.getSandboxPage().sandboxMenu.mainMenu = menu;
    this.addSandboxScreenData(this.getSandboxPage());
  }

  updateSandboxSideMenu(menu: any) {
    this.getSandboxPage().sandboxMenu.sideMenu = menu;
    this.addSandboxScreenData(this.getSandboxPage());
  }
  updateDistruptedPnrCount(count: any) {
    this.getSandboxPage().sandboxMenu.distruptedPnrCount = count;
    this.addSandboxScreenData(this.getSandboxPage());
  }
  getDistruptedPnrCount() {
    let count: any = 0;
    if (typeof this.getSandboxPage().sandboxMenu !== 'undefined') {
      if (typeof this.getSandboxPage().sandboxMenu.distruptedPnrCount !== 'undefined') {
        count = this.getSandboxPage().sandboxMenu.distruptedPnrCount;
      }
    }
    return count;
  }
  resetUser() {
    this.getSandboxPage().user = {
      preferredUserName: '',
      userEmail: '',
      userId: ''
    } as User;
  }

  getUser(): User {
    return this.getSandboxPage().user;
  }

  getEncodedUserEmail(): string {
    return this.getEncodedBase64String(this.getUser().userEmail);
  }
  getEncodedUserId(): string {
    return this.getEncodedBase64String(this.getUser().userId);
  }

  getEncodedBase64String(value: string): string {
    return Buffer.from(value).toString('base64');
  }

  getDecodedBase64String(value: string): string {
    return Buffer.from(value, 'base64').toString();
  }

  updateUser(user: User) {
    this.getSandboxPage().user = user;
  }

  getSearchFlightFormValue() {
    return this.sandboxPage.searchFlightFormValue;
  }

  resetActiveAPIConnectionProfile() {
    this.updateActiveAPIConnectionProfile(this.getConfig().trialAPIConnectionProfile);

    let apiConnectionProfileScreen: APIConnectionProfileScreen = {} as APIConnectionProfileScreen;
    apiConnectionProfileScreen = {
      activeConnectionName: this.getSandboxPage().activeAPIConnectionProfile.connectionName,
      apiConnectionProfiles: this.getSandboxPage().apiConnectionProfiles
    };

    localStorage.setItem(this.getEncodedUserEmail(), this.getEncodedBase64String(JSON.stringify(apiConnectionProfileScreen)));
  }

  getActiveAPIConnectionProfile(): APIConnectionProfile {
    if (this.getUser().userEmail != '' && localStorage.getItem(this.getUser().userEmail) && !localStorage.getItem(this.getEncodedUserEmail())) {
      localStorage.setItem(this.getEncodedUserEmail(), this.getEncodedBase64String(localStorage.getItem(this.getUser().userEmail) || ''));
    }

    if (this.getEncodedUserEmail() != '' && localStorage.getItem(this.getEncodedUserEmail())) {
      const apiConnectionProfileScreen: APIConnectionProfileScreen = JSON.parse(this.getDecodedBase64String(localStorage.getItem(this.getEncodedUserEmail()) || '') as any);

      if (apiConnectionProfileScreen.apiConnectionProfiles) {
        this.updateAPIConnectionProfiles(apiConnectionProfileScreen.apiConnectionProfiles);
      }

      if (apiConnectionProfileScreen.activeConnectionName === 'TRIAL') {
        this.updateActiveAPIConnectionProfile(this.getConfig().trialAPIConnectionProfile);
      } else {
        let activeAPIConnectionProfile = apiConnectionProfileScreen.apiConnectionProfiles.find(
          (apiConnectionProfile) => apiConnectionProfile.connectionName === apiConnectionProfileScreen.activeConnectionName
        );

        if (activeAPIConnectionProfile) {
          this.updateActiveAPIConnectionProfile(activeAPIConnectionProfile);
        }
      }
    } else {
      this.updateActiveAPIConnectionProfile(this.getConfig().trialAPIConnectionProfile);
      this.updateAPIConnectionProfiles([]);

      let apiConnectionProfileScreen: APIConnectionProfileScreen = {} as APIConnectionProfileScreen;
      apiConnectionProfileScreen = {
        activeConnectionName: this.getConfig().trialAPIConnectionProfile.connectionName,
        apiConnectionProfiles: []
      };

      localStorage.setItem(this.getEncodedUserEmail(), this.getEncodedBase64String(JSON.stringify(apiConnectionProfileScreen)));
    }

    return this.getSandboxPage().activeAPIConnectionProfile;
  }

  getAddAncilliariesScreenData() {
    return this.getSandboxPage().addAncilliariesScreen;
  }

  updateAddAncilliariesScreenData(ancliriesScreenData: any) {
    this.getSandboxPage().addAncilliariesScreen = ancliriesScreenData;
  }

  resetAddAnclilliariesScreen() {
    let addAnclilliariesScreenData = {} as AddAncilliariesScreen;
    addAnclilliariesScreenData.displayService = 'All';
    addAnclilliariesScreenData.isServiceRequestGenerate = false;
    addAnclilliariesScreenData.selectedOfferItem = [];
    addAnclilliariesScreenData.selectedOwner = '';
    addAnclilliariesScreenData.selectedOfferId = '';
    this.getSandboxPage().addAncilliariesScreen = addAnclilliariesScreenData;
  }

  getAddBaggageScreenDetail() {
    return this.getSandboxPage().addBaggageScreen;
  }

  updateAddBaggageScreenDetail(baggageScreenDetail: any) {
    this.getSandboxPage().addBaggageScreen = baggageScreenDetail;
  }

  updateActiveAPIConnectionProfile(apiConnectionProfile: APIConnectionProfile) {
    this.getSandboxPage().activeAPIConnectionProfile = apiConnectionProfile;
  }

  updateAPIConnectionProfiles(apiConnectionProfiles: APIConnectionProfile[]) {
    this.getSandboxPage().apiConnectionProfiles = apiConnectionProfiles;
  }

  getAPIConnectionProfiles(): any {
    return this.getSandboxPage().apiConnectionProfiles;
  }

  updateFindOrderScreen(findOrderScreenData: any) {
    this.getSandboxPage().findOrdersScreen = findOrderScreenData;
  }

  getFindOrderScreenData() {
    return this.getSandboxPage().findOrdersScreen;
  }

  updateDisruptedOrderViewerScreenData(disruptedOrderViewScreenDate: DisruptedOrderViewerScreen) {
    this.getSandboxPage().disruptedOrderViewerScreen = disruptedOrderViewScreenDate;
  }

  updateDisruptedOrderRequstBody(requestBody: RequestBody[]) {
    this.getSandboxPage().disruptedOrderViewerScreen.RequestBody = requestBody;
  }

  getDisruptedOrderViewerScreenData(): DisruptedOrderViewerScreen {
    return this.getSandboxPage().disruptedOrderViewerScreen;
  }

  getSearchFlightsScreenData(): SearchFlightsScreen {
    return this.getSandboxPage().searchFlightsScreen;
  }

  getAirlineOffersScreenData(): AirlineOffersScreen {
    return this.getSandboxPage().airlineOffersScreen;
  }

  updateAirlineOffersScreenData(airlineOffersScreen: AirlineOffersScreen) {
    this.getSandboxPage().airlineOffersScreen = airlineOffersScreen;
  }

  getFilterOffersScreenData(): FilterOffersScreen {
    return this.getSandboxPage().filterOffersScreen;
  }

  updateFilterOffersScreenData(filterOffersScreen: FilterOffersScreen) {
    this.getSandboxPage().filterOffersScreen = filterOffersScreen;
  }

  getOfferPriceScreenData() {
    return this.getSandboxPage().offerPriceScreen;
  }

  updateOfferPriceScreenData(offerPriceScreen: OfferPriceScreen) {
    this.getSandboxPage().offerPriceScreen = offerPriceScreen;
  }

  getPassengerDetailScreenData() {
    return this.getSandboxPage().passengerDetailScreen;
  }

  updatePassengerDetailScreenData(passengerDetailScreen: PassengerDetailScreen) {
    this.getSandboxPage().passengerDetailScreen = passengerDetailScreen;
  }

  getSeatSelectionScreenData() {
    return this.getSandboxPage().seatSelectionScreen;
  }

  updateSeatSelectionScreenData(seatSelectionScreen: SeatSelectionScreen) {
    this.getSandboxPage().seatSelectionScreen = seatSelectionScreen;
  }

  getConfirmBookingScreenData() {
    return this.getSandboxPage().confirmBookingScreen;
  }

  updateConfirmBookingScreenData(confirmBookingScreen: ConfirmBookingScreen) {
    this.getSandboxPage().confirmBookingScreen = confirmBookingScreen;
  }

  getYourBookingScreenData() {
    return this.getSandboxPage().yourBookingScreen;
  }

  updateYourBookingScreenData(yourBookingScreen: YourBookingScreen) {
    this.getSandboxPage().yourBookingScreen = yourBookingScreen;
  }

  getCancelBookingScreenData() {
    return this.getSandboxPage().cancelBookingGetRefundScreen;
  }

  updateCancelBookingScreenData(cancelBookingGetRefundScreen: CancelBookingGetRefundScreen) {
    this.getSandboxPage().cancelBookingGetRefundScreen = cancelBookingGetRefundScreen;
  }
  getChangeBookingScreenData(): ChangeFlightDateTimeScreen {
    return this.getSandboxPage().changeFlightDateTimeScreen;
  }

  updateChangeBookingScreenData(changeFlightDateTimeScreen: ChangeFlightDateTimeScreen) {
    this.getSandboxPage().changeFlightDateTimeScreen = changeFlightDateTimeScreen;
  }

  getOrderDetailsScreenData(): OrderDetailsScreen {
    return this.getSandboxPage().orderDetailsScreen;
  }

  updateOrderDetailsScreenData(orderDetailsScreen: OrderDetailsScreen) {
    this.getSandboxPage().orderDetailsScreen = orderDetailsScreen;
  }

  getPassengerScreenDetail() {
    return this.getSandboxPage().passengerDetailScreen;
  }

  widthChange70() {
    this.getSandboxPage().sandboxMenu.widthMainMenu = 'width70';
    this.sandboxScreenDataSource.next(this.getSandboxPage());
  }

  // widthChange100() {
  //   this.getSandboxPage().sandboxMenu.widthMainMenu = 'width100';
  //   this.sandboxScreenDataSource.next(this.getSandboxPage());
  // }

  getFindOrderFormValue(): string {
    return this.getSandboxPage().findOrderFormValue;
  }

  setFindOrderFormValue(findOrderFormValue: string) {
    this.getSandboxPage().findOrderFormValue = findOrderFormValue;
  }

  getBookingReferences() {
    return this.getSandboxPage().bookingReferences;
  }

  addSandboxScreenData(sandboxScreenData: any) {
    this.sandboxScreenDataSource.next(sandboxScreenData);
  }

  resetRequest() {
    this.getSandboxPage().requestMap = new Map();
  }

  getRequest() {
    return this.getSandboxPage().requestMap;
  }

  resetResponse() {
    this.getSandboxPage().responseMap = new Map();
  }

  getResponse() {
    return this.getSandboxPage().responseMap;
  }

  getChangeFlightDateTimeScreenData(): ChangeFlightDateTimeScreen {
    return this.getSandboxPage().changeFlightDateTimeScreen;
  }

  resetXMLLogOverride(): string {
    return (this.getSandboxPage().xmlLogOverride = '');
  }

  getXMLLogOverride(): string {
    return this.getSandboxPage().xmlLogOverride || '';
  }

  setXMLLogOverride(xmlLogOverride: string): string {
    return (this.getSandboxPage().xmlLogOverride = xmlLogOverride);
  }

  getRequestFromMap(key: string): string {
    return this.getSandboxPage().requestMap.get(key) || '';
  }

  updateRequestMap(key: string, xml: string) {
    this.getSandboxPage().requestMap.set(key, xml);
    this.updateXMLLogsMap(key, xml, 'RQ');
  }

  getResponseFromMap(key: string): string {
    key = this.keyMapper(key);
    return this.getSandboxPage().responseMap.get(key) || '';
  }

  updateResponseMap(key: string, xml: string) {
    key = this.keyMapper(key);
    this.getSandboxPage().errorMessage = '';
    this.getSandboxPage().warningMessage = '';
    const jsonObject = this.xmlToJsonParserService.parseXMLToJSON(xml);

    if (jsonObject && (xml.includes('Errors') || xml.includes('ns2:Error'))) {
      let errorTag = xml.includes('ns2:Error') ? 'NS2:ERROR' : 'ERROR';
      this.getSandboxPage().errorMessage = this.getError(jsonObject, errorTag);
    }

    if (jsonObject && (xml.includes('Warnings') || xml.includes('ns2:Warning'))) {
      let warningTag = xml.includes('ns2:Warning') ? 'NS2:WARNING' : 'WARNING';
      this.getSandboxPage().warningMessage = this.getWarning(jsonObject, warningTag);
    }

    if (!xml.includes('soap:Envelope')) {
      this.getSandboxPage().errorMessage = 'Some error occured. Please check your API connection profile.';
    }

    this.getSandboxPage().responseMap.set(key, xml);
    this.updateXMLLogsMap(key, xml, 'RS');
  }

  updateResponseMapFromNonAPI(key: string, xml: string) {
    key = this.keyMapper(key);

    this.getSandboxPage().responseMap.set(key, xml);
    this.updateXMLLogsMap(key, xml, 'RS');
  }

  keyMapper(key: string): string {
    key = key.replace('OrderCreate', 'OrderView');
    key = key.replace('OrderRetrieve', 'OrderView');
    return key;
  }

  getErrorMessage() {
    return this.getSandboxPage().errorMessage;
  }

  setErrorMessage(errorMessage: string) {
    this.getSandboxPage().errorMessage = errorMessage;
  }

  getWarningMessage() {
    return this.getSandboxPage().warningMessage;
  }

  getJsonRequestFromMap(key: string): string {
    return this.getSandboxPage().jsonRequestMap.get(key) || '';
  }

  updateJsonRequestMap(key: string, json: string) {
    this.getSandboxPage().jsonRequestMap.set(key, json);
  }

  resetXMLLogsMap() {
    this.getSandboxPage().xmlLogsMap = new Map();
  }

  getXMLLogsMap(): Map<string, string> {
    return this.getSandboxPage().xmlLogsMap;
  }

  async updateXMLLogsMap(key: string, xml: string, suffix: string) {
    let xmlLogOverride = this.getSandboxPage().xmlLogOverride;
    const xmlLogOverrideValues = (xmlLogOverride && xmlLogOverride.split('#')) || [];

    const values = key.split('/');
    let urlKey = '';
    for (let i = values.length - 3; i < values.length; i++) {
      if (values[i]) {
        urlKey += values[i];
      }
    }

    if (xmlLogOverrideValues?.length > 0) {
      urlKey = urlKey.replace(xmlLogOverrideValues[0], xmlLogOverrideValues[1]);
    }

    //let label = urlKey + suffix + (this.getSandboxPage().xmlLogsMap.size + 1);
    let label = urlKey + suffix;
    // this.getSandboxPage().xmlLogsMap.set(label, xml);
    await this.xmlLogIndexdbService.addXmlLog({ label: label, xml: xml }, this.getIndexDBConfig());
  }

  async updateXMLLogsMapWithHeaders(jsonData: string) {
    const xml = this.xmlToJsonParserService.buildXMLFromJSON(JSON.parse(jsonData));
    // let label = 'HttpHeaders' + (this.getSandboxPage().xmlLogsMap.size + 1);
    let label = 'HttpHeaders';
    //this.getSandboxPage().xmlLogsMap.set(label, xml);
    await this.xmlLogIndexdbService.addXmlLog({ label: label, xml: xml }, this.getIndexDBConfig());
  }

  resetPerformanceLogs() {
    this.getSandboxPage().performanceLogs = [];
  }

  getPerformanceLogs(): PerformanceLog[] {
    return this.getSandboxPage().performanceLogs;
  }

  async updatePerformanceLogsMap(key: string, responseTime: string) {
    const values = key.split('/');
    let urlKey = '';
    for (let i = values.length - 3; i < values.length; i++) {
      urlKey += values[i];
    }
    // this.getSandboxPage().performanceLogs.push({ key: urlKey, responseTime: responseTime });
    await this.perfomanceLogIndexdbService.addPerfomanceLog({ label: urlKey, responseTime: responseTime }, this.getIndexDBConfig());
  }

  getAgentResidenceCountryCode() {
    return 'GB';
  }
  getCitizenshipCountryCode() {
    return 'GB';
  }

  private getError(jsonObject: any, errorTag: any): string {
    if (errorTag === 'ERROR') {
      return this.getErrorOrWarningMessage(jsonObject, errorTag);
    }
    return this.getErrorOrWarningMessage_19_1(jsonObject, errorTag);
  }

  private getWarning(jsonObject: any, warningTag: any): string {
    if (warningTag === 'WARNING') {
      return this.getErrorOrWarningMessage(jsonObject, warningTag);
    }
    return this.getErrorOrWarningMessage_19_1(jsonObject, warningTag);
  }

  private getErrorOrWarningMessage(jsonObject: any, errorOrWarningType: string): string {
    try {
      let sandboxResponseEnvelop = jsonObject['SOAP:ENVELOPE'];
      let sandboxResponseBody = sandboxResponseEnvelop['SOAP:BODY'];
      const type: string = Object.keys(sandboxResponseBody[0]).at(0) || '';
      let sandboxResponseType = sandboxResponseBody[0][type][0];
      let errorOrWarningMessage = '';
      if (sandboxResponseType[errorOrWarningType + 'S'][0][errorOrWarningType]) {
        sandboxResponseType[errorOrWarningType + 'S'][0][errorOrWarningType].forEach((errorOrWarning: any) => {
          if (errorOrWarningMessage.length > 0) {
            errorOrWarningMessage += '\n';
          }
          if (errorOrWarning.$ && errorOrWarning.$.SHORTTEXT) {
            errorOrWarningMessage += errorOrWarning.$.SHORTTEXT + ' ';
          }
          if (errorOrWarning._) {
            errorOrWarningMessage += errorOrWarning._;
          } else if (errorOrWarning && typeof errorOrWarning !== 'object') {
            errorOrWarningMessage += errorOrWarning;
          }
        });
      }
      // console.log('Error / Warning Message Message From API : ', errorOrWarningMessage);
      return errorOrWarningMessage;
    } catch (e) {
      // console.log('Unable to fetch Error / Warning Message from API : ', jsonObject, e);
      return 'Unable to fetch ' + errorOrWarningType + ' Message from API';
    }
  }

  getErrorOrWarningMessage_19_1(jsonObject: any, errorOrWarningType: string): string {
    try {
      let sandboxResponseEnvelop = jsonObject['SOAP:ENVELOPE'];
      let sandboxResponseBody = sandboxResponseEnvelop['SOAP:BODY'];
      const type: string = Object.keys(sandboxResponseBody[0]).at(0) || '';
      let sandboxResponseType = sandboxResponseBody[0][type][0];
      let errorOrWarningMessage = '';
      if (errorOrWarningType === 'NS2:WARNING' && sandboxResponseType['NS2:RESPONSE'][0][errorOrWarningType].length > 0) {
        sandboxResponseType['NS2:RESPONSE'][0][errorOrWarningType].forEach((errorOrWarning: any) => {
          if (errorOrWarningMessage.length > 0) {
            errorOrWarningMessage += '\n';
          }
          errorOrWarningMessage = errorOrWarning['NS2:CODE'][0] + ' - ' + errorOrWarning['NS2:DESCTEXT'][0];
        });
      } else {
        if (sandboxResponseType[errorOrWarningType] && sandboxResponseType[errorOrWarningType].length > 0) {
          sandboxResponseType[errorOrWarningType].forEach((errorOrWarning: any) => {
            if (errorOrWarningMessage.length > 0) {
              errorOrWarningMessage += '\n';
            }
            errorOrWarningMessage = errorOrWarning['NS2:CODE'][0] + ' - ' + errorOrWarning['NS2:DESCTEXT'][0];
          });
        }
      }
      // console.log('Error / Warning Message Message From API : ', errorOrWarningMessage);
      return errorOrWarningMessage;
    } catch (e) {
      // console.log('Unable to fetch Error / Warning Message from API : ', jsonObject, e);
      return 'Unable to fetch ' + errorOrWarningType + ' Message from API';
    }
  }

  //index db
  async getPerfomanceLogFromIndexDB() {
    let perfomanceLogLists: any = [];
    await this.perfomanceLogIndexdbService.getPerfomanceLogs(this.getIndexDBConfig()).then((logLists: any) => {
      logLists.forEach((logList: { label: string; responseTime: string }) => {
        perfomanceLogLists.push({ key: logList.label, value: logList.responseTime });
      });
    });
    return perfomanceLogLists;
  }
  async getXmlLogFromIndexDB() {
    let xmlLogLists: any[] = [];
    await this.xmlLogIndexdbService.getXmlLogs(this.getIndexDBConfig()).then((logLists: any) => {
      logLists.forEach((logList: { label: string; xml: string }) => {
        xmlLogLists.push({ key: logList.label, value: logList.xml });
      });
    });
    return xmlLogLists;
  }
  async deleteAllLogFromIndexDB() {
    if (typeof this.getIndexDBConfig() !== 'undefined' && this.getIndexDBConfig() !== null) {
      await this.xmlLogIndexdbService.deleteAllLogs(this.getIndexDBConfig());
      await this.perfomanceLogIndexdbService.deleteAllLogs(this.getIndexDBConfig());
    }
  }
  //end
}
